

function linkUrl(actionData) {
    let d = actionData;
    if (!d || !d.mainToggle) return '#';
    switch (d.mainToggle) {
        case "goto-element":
            return d.element;
        case "goto-url": {
            let url = d.url ? d.url : '';
            if (url.startsWith('#')) return url; // for #checkout
            if (url.startsWith('https://') || url.startsWith('http://')) return url;
            return '//' + url;
        }
        case "submit-step":
            return '#submit-step';
        case "next-step":
            return '#next-step';
        case "no-link":
            return '#no-link';
        case "yes-link":
            return d.productId ? '#yes-link-'+d.productId : '#yes-link';
        case "show-popup":
            return '#popup-' + (d.popup || '');
        case "close-popup":
            return '#close-popup';
        default:
            return '#no-action';
    }
}

function linkTarget(actionData) {
    let d = actionData;
    if (!d || !d.mainToggle) return '_self';
    switch (d.mainToggle) {
        case "goto-url":
            return d.target ? d.target : '_self';
        default:
            return '_self';
    }
}

export {
    linkUrl,
    linkTarget
}
